/**
 * Paid-media dashboards lack backend authorization, so the frontend is their only boundary;
 * shared predicates keep navigation and route guards fail-closed while retaining cached data.
 */
import { isExternalUser } from 'src/hooks/isExternalUser';
import type {
  CampaignDesiredStateDto,
  PermissionAssignmentDto,
  UserContextDto,
} from 'src/store/generated/leela-api-generated';

export interface InsightsAccessInput {
  readonly assignments: readonly PermissionAssignmentDto[];
  readonly isError: boolean;
  readonly publishers: readonly string[];
}

export function hasInsightsPermissionData ({
  assignments,
  isError,
}: InsightsAccessInput): boolean {
  return !isError || assignments.length > 0;
}

export function canAccessInternalInsights (input: InsightsAccessInput): boolean {
  return hasInsightsPermissionData(input) && !isExternalUser(input.assignments);
}

export function canAccessPublisherInsights (
  input: InsightsAccessInput,
  publisher: CampaignDesiredStateDto['publisher'],
): boolean {
  return hasInsightsPermissionData(input) && input.publishers.includes(publisher);
}

export function canAccessPaidMediaDashboards (user: UserContextDto | undefined): boolean {
  return user?.userType === 'internal';
}
